// App shell — landing page is served from index.html directly
export default function App() {
  return null;
}
